import React from 'react';
import GenericNomenclatureList from './GenericNomenclatureList';
import { useEquipmentMutations } from '../../../hooks/useNomenclatures';

const EquipmentList = ({ items, onUpdate }) => {
  const mutations = useEquipmentMutations();

  const fields = [
    { name: 'category', label: 'Category', type: 'text', placeholder: 'e.g., Life Support, Surgical' }
  ];

  return (
    <GenericNomenclatureList
      items={items}
      type="equipment"
      title="Equipment"
      fields={fields}
      mutations={mutations}
      onUpdate={onUpdate}
    />
  );
};

export default EquipmentList;

